<template>
  <LimitReachedModalsQrs
    v-if="showLimitReachedModal"
    v-model:open="showLimitReachedModal"
    @close="closeHandler" />
</template>

<script setup>
import { useQrsTableStore } from "@/stores/qrs"
import { storeToRefs } from "pinia"
import LimitReachedModalsQrs from "./LimitReachedModalsQrs.vue"

const { showLimitReachedModal } = storeToRefs(useQrsTableStore())

function closeHandler() {
  showLimitReachedModal.value = false
}
</script>
